<template>
  <div>
    <el-group-title title="财务信息" class="d_jump" index="moneyInfo">
      <template slot="groupTitle">
        <el-form
          :model="form"
          :rules="rules"
          ref="form"
          label-width="163px"
          :inline="true"
        >
          <el-row>
            <el-col :span="12">
              <el-form-item label="价格地区：" prop="priceRegion">
                {{ form.priceRegion }}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="计税方法：" prop="taxMethod">
                {{ form.taxMethod }}
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="发票类型：" prop="taxType">
                {{ form.taxType }}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="签订地点：" prop="placeSign">
                {{ form.placeSign }}
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="合同份数：" prop="numberCopies">
                {{ form.numberCopies }}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="对方联系人：" prop="phonePerson">
                {{ form.phonePerson }}
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="供应商纳税人类型：" prop="taxpayer">
                {{ form.taxpayer }}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="物资来源：" prop="materialSources">
                {{ form.materialSources }}
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="支付系数：" prop="paymentCoefficient">
                {{ form.paymentCoefficient }}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="预付款：" prop="advanceCharge">
                {{ form.advanceCharge }}
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="账户名称：" prop="titleAccount">
                {{ form.titleAccount }}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="开户行账号：" prop="accountNumber">
                {{ form.accountNumber }}
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="开户行名称：" prop="accountName">
                {{ form.accountName }}
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </template>
    </el-group-title>
  </div>
</template>

<script>
export default {
  name: "financeInfo",
  props: {
    attachment: {
      type: Array,
      default() {
        return [];
      }
    },
    financeInfo: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      form: {
        priceRegion: "北京",
        taxMethod: "增值税",
        taxType: "一般税",
        placeSign: "北京",
        numberCopies: "2",
        phonePerson: "小名",
        taxpayer: "自然纳税人",
        materialSources: "北京",
        paymentCoefficient: "1",
        advanceCharge: "100000",
        titleAccount: "北京银行",
        accountNumber: "10000",
        accountName: "6213"
      },
      rules: {},
      tableData: [
        {
          id: "1",
          textName: "采购清单.xlsx",
          txtlarge: "12Kb"
        }
      ]
    };
  },
  watch: {
    financeInfo() {
      this.form = this.financeInfo;
    },
    attachment() {
      this.tableData = this.attachment;
    }
  }
};
</script>

<style scoped lang="scss">
/deep/.el-table {
  /deep/th {
    padding: 0;
    heigth: 36px;
    line-height: 36px;
  }
  .el-table__body {
    .cell {
      height: 36px;
      line-height: 36px;
    }
  }
}
</style>
